import { render, staticRenderFns } from "./TxConfirmationWindow.vue?vue&type=template&id=ab13246c&"
import script from "./TxConfirmationWindow.vue?vue&type=script&lang=js&"
export * from "./TxConfirmationWindow.vue?vue&type=script&lang=js&"
import style0 from "./TxConfirmationWindow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports